<template>
  <div>
    <iframe
      scrolling="no"
      width="300"
      height="400"
      frameBorder="0"
      allowTransparency="true"
      :src="setSrc"
    ></iframe>
  </div>
</template>

<script>
export default {
  data() {
    return {
      src: "https://open.work.weixin.qq.com/wwopen/sso/qrConnect?",
    };
  },
  computed: {
    setSrc() {
      const redirectUri = encodeURIComponent(
        "https://newsso.bthhotels.com/accountlogin/WxBack"
      );
      // ${this.state}
      const _url =
        "https://open.work.weixin.qq.com/wwopen/sso/qrConnect?" +
        "appid=wx6a1abf70a2b1f203&agentid=1000012&redirect_uri=" +
        redirectUri +
        "&state=" +
        `${this.state}_qywx` +
        "&href=data:text/css;base64,LmltcG93ZXJCb3ggLnFyY29kZSB7d2lkdGg6MjIwcHg7bWFyZ2luLXRvcDowO30NCi5pbXBvd2VyQm94IC50aXRsZSB7ZGlzcGxheTogbm9uZTt9DQouaW1wb3dlckJveCAuaW5mbyB7d2lkdGg6IDIyMHB4O30NCi5zdGF0dXNfaWNvbiB7ZGlzcGxheTogbm9uZX0NCi5pbXBvd2VyQm94IC5zdGF0dXMge3RleHQtYWxpZ246IGNlbnRlcjt9IA==";
      return _url;
    },
  },
  props: {
    state: {
      type: String,
      default: "",
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@css/style.scss";
[v-cloak] {
  display: none;
}
</style>
